import { Box } from "@mui/material";
import styles from "./ErrorBox.module.css";

interface  ErrorBoxProps {
    description: string
}

export const ErrorBox = ({description}: ErrorBoxProps) => {
    return (
        <Box className={styles.container}>
            <h1 className={styles.title}>4<span>0</span>4</h1>
            <h1 className={styles.description}>{description}</h1>
        </Box>
    )
}